import { MealTime } from "@/clients/models/MealTime";
import FilledButton from "@/components/button/filled-button";
import { ProfilePageContainer } from "@/components/container/profile-page-container";
import { PageTitleComponent } from "@/components/page-title";
import { MealTimeSegmentButtons } from "@/components/segment-buttons/meal-time-segment-buttons";
import {
  SelectedMealList,
  SelectedMealListPlaceholder,
} from "@/features/go-to/components/selected-meal-list";
import { useGetGotoMeal } from "@/hooks/requests/go-to/meal/use-get-goto-meal";
import { useSearchParams } from "@/hooks/router/use-search-params";
import { useIonRouter } from "@ionic/react";
import { ReselectAllFavouriteButton } from "../../components/reselect-all-favourite-button";

export default function MyFavouriteFood() {
  const navigation = useIonRouter();
  const searchParams = useSearchParams();
  const mealTime =
    (searchParams.get("mealTime") as MealTime) ?? MealTime.BREAKFAST;
  const { selectedMeals, isLoading } = useGetGotoMeal(mealTime);

  return (
    <ProfilePageContainer actionButton={<ReselectAllFavouriteButton />}>
      <PageTitleComponent
        title="My Favourites"
        description="Add your favourite meals that you want to include in your meal plan."
      />
      <MealTimeSegmentButtons
        selected={mealTime}
        onSelect={(mealTime) => {
          const newSearchParams = new URLSearchParams(searchParams);
          newSearchParams.set("mealTime", mealTime);
          navigation.push(
            `/profiling/favourites?${newSearchParams.toString()}`,
            "forward",
          );
        }}
      />
      <div className="flex-1 w-full flex flex-col gap-4">
        {isLoading ? (
          <SelectedMealListPlaceholder />
        ) : (
          <SelectedMealList meals={selectedMeals?.meals ?? []} />
        )}
      </div>
      <div className="flex flex-col gap-4 mt-auto my-8">
        <FilledButton
          size="small"
          color="dark"
          onClick={() => {
            navigation.push(`/profiling/favourites/${mealTime}`, "forward");
          }}
        >
          Change {mealTime.toLowerCase()}
        </FilledButton>
      </div>
    </ProfilePageContainer>
  );
}
